import React from 'react';
import { PhoneCallIcon, MailIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { GlassCall } from './ContactButtons';
export function UrgentCTA() {
  return <section className="relative w-full overflow-hidden bg-ink py-16 sm:py-24" data-id="element-185" data-mp="3poz76b6ypddc">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(242,194,48,0.12),transparent_65%)]" data-id="element-186" data-mp="3pr26jlu08iuq" />
      <div className="relative mx-auto max-w-3xl px-5 text-center" data-id="element-187" data-mp="2xxt87y2z9lpn">
        <Reveal data-id="element-188" data-mp="2xzmg1gpbubz8">
          <div className="relative mx-auto flex h-24 w-24 items-center justify-center" data-id="element-189" data-mp="2y05tak418c6x">
            <span aria-hidden="true" className="absolute inset-0 rounded-full border border-gold-light/60 animate-ring-ping" data-id="element-190" data-mp="321hg6hviujbf" />
            <span aria-hidden="true" className="absolute inset-0 rounded-full border border-call/50 animate-ring-ping [animation-delay:1.2s]" data-id="element-191" data-mp="3bydnik9oozee" />
            <span className="relative flex h-20 w-20 items-center justify-center rounded-full bg-gold-light/10 ring-1 ring-gold-light/40" data-id="element-192" data-mp="r6ah48diejiw">
              <PhoneCallIcon className="h-8 w-8 animate-bell-shake text-gold-light" aria-hidden="true" data-id="element-193" data-mp="16c4yl3h7cyqf" />
              <MailIcon className="absolute -bottom-1 -right-1 h-7 w-7 rounded-full bg-ink p-1 text-call" aria-hidden="true" data-id="element-194" data-mp="12ajht71js0ay" />
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-195" data-mp="nf4umfzaqa0m">
          <h2 className="mt-9 font-serif text-4xl leading-tight text-gold-light sm:text-5xl lg:text-6xl" data-id="element-196" data-mp="ngeunappls9w">
            ¡No dejes pasar esta ocasión!
          </h2>
        </Reveal>
        <Reveal delay={0.18} data-id="element-197" data-mp="emjobzcupvso">
          <p className="mt-5 font-sans text-sm font-medium uppercase tracking-[0.3em] text-white/60" data-id="element-198" data-mp="enuuu6xolhnh">
            Respuesta Inmediata — Línea Gratuita
          </p>
        </Reveal>
        <Reveal delay={0.26} data-id="element-199" data-mp="4p5a86eehj3j">
          <div className="mt-10 flex justify-center" data-id="element-200" data-mp="4odl9efb6jm8">
            <GlassCall phone="header" className="sm:px-10 sm:py-5 sm:text-lg" data-id="element-201" data-mp="3vuol578l1ebz">
              Llamar Ahora +1 650 676 8112
            </GlassCall>
          </div>
        </Reveal>
      </div>
    </section>;
}